export default __webpack_public_path__ + "static/media/4typesCard4.baacb742.png";